import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/reportedPosts"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Delete = async (id) => {
    return await axiosInstance(options).post(`${path}/delete?o_id=${id}`)
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}
